import validator from "validator";

export const phoneValidation = (_, value, cb) => {
  if (validator.isMobilePhone(value)) {
    return cb();
  }

  return cb("What is your phone number?");
};
